import { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../actions/actions";

const useGrantApplicationAction = () => {
    const dispatch = useDispatch();

    // STEP 1 DATA
    const fetchCountries = useCallback((payload = {}) => {
        dispatch(actions.fetchCountries(payload));
    }, [dispatch]);

    const fetchCounties = useCallback((payload = {}) => {
        dispatch(actions.fetchCounties(payload));
    }, [dispatch]);

    const fetchCurrencies = useCallback((payload = {}) => {
        dispatch(actions.fetchCurrencies(payload));
    }, [dispatch]);


    const findOrganization = useCallback((payload) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.findOrganization(payload, resolve, reject));
        });
    }, [dispatch]);


    const createRequest = useCallback((payload) => {
        dispatch(actions.createRequest(payload));
    }, [dispatch]);


    const requestDocuments = useCallback((payload) => {
        dispatch(actions.requestDocuments(payload));
    }, [dispatch]);

    const requestDocumentsList = useCallback((payload) => {
        dispatch(actions.requestDocumentsList(payload));
    }, [dispatch]);

    const requestNumber = useCallback((payload) => {
        return new Promise((resolve) => {
            dispatch(actions.requestNumber(payload, resolve));
        });
    }, [dispatch]);


    return {
        fetchCountries,
        fetchCounties,
        fetchCurrencies,
        findOrganization,
        createRequest,
        requestDocuments,
        requestDocumentsList,
         requestNumber,
    };
};

export default useGrantApplicationAction;
